<ui-dialog
    (primaryButtonPressed)="onAdd()"
    primaryButtonLabel="{{ 'add' | appTranslate }}"
    secondaryButtonLabel="{{ 'cancel' | appTranslate }}"
    (closing)="closeDialog()"
    secondaryButtonType="ghost"
    size="small"
    [isCloseable]="true"
    [open]="openDialog"
    [header]="header"
>
    <div class="flex justify-space-between">
        <app-search
            #searchBar
            [placeholder]="searchPlaceholder"
            (onSearch)="onSearch($event)"
            [minWidth]="searchWidth"
            class="margin-bottom-1"
        ></app-search>

        <app-filter
            *ngIf="!isAutoArchive"
            [groups]="filterGroups"
            [useRaisedButton]="false"
            (filter)="onFilter()"
        ></app-filter>
    </div>

    <div class="question-container">
        <div
            class="flex margin-left-3 padding-top-1 padding-bottom-1 align-items-center"
            *ngFor="let question of questions; let i = index"
        >
            <mat-checkbox
                class="align-self-center"
                [(ngModel)]="question.isSelected"
                name="selectQuestion"
                type="checkbox"
                [attr.data-cy]="question.question"
            >
            </mat-checkbox>

            <div class="margin-left-3">
                <div [attr.data-cy]="'question-' + i">{{ question.question }}</div>
                <div class="question-type-info">
                    {{
                        isAutoArchive ? '' : (jobPostingType[question.atsJobPostingQuestionTypeId] | appTranslate) + ','
                    }}
                    {{ question.isRequired ? ('applicant-tracker.required' | appTranslate) + ',' : '' }}
                    {{ question.accessLevelLabel | appTranslateOptions: accessLevelDisplay }}
                </div>
            </div>
        </div>
    </div>
</ui-dialog>
